import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-agent",
  "use": "icon-icon-agent-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-agent\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 243.2m-179.2 0a179.2 179.2 0 1 0 358.4 0 179.2 179.2 0 1 0-358.4 0Z\" p-id=\"1602\" /><path d=\"M911.9 900.3L769 494.6c-6.8-16.5-23.3-27.4-41.6-27.4H296.6c-18.3 0-34.8 10.8-41.6 27.4L112.1 900.3c-11.8 28.6 9.9 59.7 41.6 59.7h716.7c31.6 0 53.3-31.1 41.5-59.7z m-344.8-45.4c3.4 30.4-18.4 57.9-48.8 61.3-30.4 3.4-57.8-18.4-61.3-48.8-0.5-4.1-0.4-8.5 0-12.4l30.8-273h-9.4c-18 0-28.6-20.2-18.4-35l33.6-48.7c8.9-12.9 27.9-12.9 36.7 0l33.6 48.7c10.2 14.8-0.4 35-18.4 35h-9.4l31 272.9z\" p-id=\"1603\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-agent.svg
// module id = wmu9
// module chunks = 46